import React, { useEffect, useState } from "react";
import { PageHeader } from "./Pengumuman";
import { AlertTriangle, Plus } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";
import { laporanAPI } from "../lib/api";

const statusColor = { baru: "bg-blue-100 text-blue-700", proses: "bg-amber-100 text-amber-700", selesai: "bg-emerald-100 text-emerald-700" };

const LaporanKejadian = () => {
  const { user } = useApp();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", category: "Infrastruktur", deskripsi: "" });

  const load = () => laporanAPI.list().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.title || !form.deskripsi) { toast.error("Judul dan deskripsi wajib"); return; }
    try { await laporanAPI.create(form); setForm({ title: "", category: "Infrastruktur", deskripsi: "" }); setOpen(false); toast.success("Laporan Anda dikirim"); load(); } catch { toast.error("Gagal"); }
  };
  const updateStatus = async (id, status) => { try { await laporanAPI.update(id, { status }); toast.success("Status diperbarui"); load(); } catch { toast.error("Gagal"); } };

  return (
    <div>
      <PageHeader title="Laporan Kejadian" subtitle="Laporkan kejadian atau masalah di lingkungan" icon={AlertTriangle}
        action={<Dialog open={open} onOpenChange={setOpen}><DialogTrigger asChild><Button className="brand-btn"><Plus className="h-4 w-4 mr-1" /> Buat Laporan</Button></DialogTrigger>
          <DialogContent><DialogHeader><DialogTitle>Laporan Baru</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Judul</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
              <div><Label>Kategori</Label><Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>
                <SelectItem value="Infrastruktur">Infrastruktur</SelectItem><SelectItem value="Keamanan/Ketertiban">Keamanan / Ketertiban</SelectItem><SelectItem value="Kebersihan">Kebersihan</SelectItem><SelectItem value="Lingkungan">Lingkungan</SelectItem>
              </SelectContent></Select></div>
              <div><Label>Deskripsi</Label><Textarea rows={4} value={form.deskripsi} onChange={(e) => setForm({ ...form, deskripsi: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={submit} className="brand-btn">Kirim Laporan</Button></DialogFooter>
          </DialogContent></Dialog>}
      />
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((l) => (
          <Card key={l.id} className="card-hover"><CardContent className="p-5">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div><Badge variant="secondary" className="bg-slate-100 text-slate-700 text-xs mb-2">{l.category}</Badge><h3 className="font-bold text-slate-800">{l.title}</h3></div>
              <Badge className={`${statusColor[l.status]} hover:${statusColor[l.status]} capitalize`}>{l.status}</Badge>
            </div>
            <p className="text-sm text-slate-600 mb-2">{l.deskripsi}</p>
            <div className="text-xs text-slate-400 flex items-center justify-between"><span>{l.pelapor} • Blok {l.blok} • {l.tanggal}</span></div>
            {user.role !== "warga" && l.status !== "selesai" && (
              <div className="flex gap-2 mt-3 pt-3 border-t border-slate-100">
                {l.status === "baru" && <Button size="sm" variant="outline" onClick={() => updateStatus(l.id, "proses")}>Proses</Button>}
                <Button size="sm" className="brand-btn" onClick={() => updateStatus(l.id, "selesai")}>Selesai</Button>
              </div>
            )}
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
};
export default LaporanKejadian;
